import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';
import AddRegionCountryPopup from '../Popups/Region_popup_AddCountry';

const Region_tab_Countries: React.FC<IdProps> = ({ id }) => {
    const [data, setData] = useState<[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [id]);

    function getTableData() {
        DataService.get<[]>('api/v1/RegionCountries/ByRegion/' + id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/RegionCountries/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'countryId', visible: false },
        { title: 'Country', dataProp: 'country.name', sort: 'asc' }
    ];
    if (isAuthorizedFor(ApplicationFunctions.EditRegion)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtRegionCountries'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Country'
                navigateUrl='/plm/ItemSetup/Country/'
            />
            {showPopup && <AddRegionCountryPopup show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} regionId={id} />}
        </>
    );
}
export default Region_tab_Countries;